export default (function (language) {
  var strings = {
    en: {
      passwordLabel: 'Password',
      repeatLabel: 'Repeat Password'
    }
  };
  var usingLanguage = Object.keys(strings).indexOf(language) === -1 ? 'en' : language;
  return strings[usingLanguage];
});